export const MainUrl = process.env.REACT_APP_PUBLIC_PATH;